module.exports = __webpack_public_path__ + "static/media/naf.b06a98f2.svg";